import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { renderRedirect } from "../../util";
import { addReferralCode, verifyOTP, getOTP } from "./api";
import { getCurrentWorkflowId } from "../../util/login";
import $ from "jquery";
import { spinnerService } from "../../Components/spinner.service";
import Footer from "../../Components/footer";

class VerifyMobileOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: localStorage.getItem("mobile"),
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      formErrors: { otp1: "", otp2: "", otp3: "", otp4: "" },
      otpValid: false,
      errorMessage: "",
    };
  }

  async componentDidMount() {
    $("#otp-screen .form-control").keyup(function () {
      if (this.value.length == 0) {
        $(this).blur().parent().prev().children(".form-control").focus();
      } else if (this.value.length == this.maxLength) {
        $(this).blur().parent().next().children(".form-control").focus();
      }
    });

    this.autoFocus();
  }

  autoFocus = () => {
    $("#first").focus();
  };

  _renderRedirect = async () => {
    try {
      const workFlowObj = await getCurrentWorkflowId().catch(() => {});
      const redirectUrl = workFlowObj?.currentWorkflowRedirect ? "/" + workFlowObj.currentWorkflowRedirect : "/email";
      renderRedirect(this.props, redirectUrl, false);
    } catch (e) {
      renderRedirect(this.props, "/email", false);
    }
  };

  _verifyOTP = async () => {
    spinnerService.show("mainSpinner", "Please wait...");

    let otpValue =
      this.state.otp1 + this.state.otp2 + this.state.otp3 + this.state.otp4;

    let otp = await verifyOTP(
      localStorage.getItem("mobile"),
      localStorage.getItem("session_id"),
      otpValue
    ).catch((err) => {
      spinnerService.hide("mainSpinner");

      let errMsg = "Error in verifying OTP";
      if (err) {
        if (err.message) {
          errMsg = err.message;
        } else if (err.graphQLErrors && err.graphQLErrors[0]) {
          errMsg = err.graphQLErrors[0].message;
        }
      }
      this.setState({ errorMessage: errMsg });
    });

    if (otp && otp.errors && otp.errors.length > 0) {
      spinnerService.hide("mainSpinner");
      this.setState({ errorMessage: otp.errors[0].message });
      return;
    }

    if (otp && otp.data && otp.data.verify_session_otp.status) {
      localStorage.setItem("token", otp.data.verify_session_otp.token);
      spinnerService.hide("mainSpinner");

      //for adding referral code if any
      if (localStorage.getItem("referral")) {
        let res = await addReferralCode(
          localStorage.getItem("referral")
        ).catch((errors) => {
          spinnerService.hide("mainSpinner");
    
          console.log("add referral api response", res);
        });
      }
      //for adding referral code if any

      this._renderRedirect();
    } else if (otp && !otp.data.verify_session_otp.status) {
      spinnerService.hide("mainSpinner");

      this.setState({ errorMessage: otp.data.verify_session_otp.message });
    }
  };

  _resendOTP = async () => {
    spinnerService.show("mainSpinner", "Resending OTP...");
    let mobile = localStorage.getItem("mobile");
    let otp = await getOTP(mobile).catch((res) => {
      spinnerService.hide("mainSpinner");
      this.setState({ errorMessage: "Error in resending OTP" });
    });

    if (otp?.data?.get_session_otp?.status) {
      const sessionId = otp.data.get_session_otp?.session_id;
      localStorage.setItem("session_id", sessionId);
      spinnerService.hide("mainSpinner");
      this.setState({
        errorMessage: "OTP has been resent successfully.",
        otp1: "",
        otp2: "",
        otp3: "",
        otp4: "",
      });
      // Clear inputs
      $("#first").val("").focus();
      $("input[name=otp2]").val("");
      $("input[name=otp3]").val("");
      $("input[name=otp4]").val("");
    } else {
      spinnerService.hide("mainSpinner");
      this.setState({ errorMessage: "Failed to resend OTP. Please try again." });
    }
  };

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let otpValid = this.state.otpValid;

    switch (fieldName) {
      case "otp1":
        otpValid = value.length == 1;
        fieldValidationErrors.otp1 = otpValid ? "" : " is invalid";
        break;
      case "otp2":
        otpValid = value.length == 1;
        fieldValidationErrors.otp2 = otpValid ? "" : " is invalid";
        break;
      case "otp3":
        otpValid = value.length == 1;
        fieldValidationErrors.otp3 = otpValid ? "" : " is invalid";
        break;
      case "otp4":
        otpValid = value.length == 1;
        fieldValidationErrors.otp4 = otpValid ? "" : " is invalid";
        break;
      default:
        break;
    }
    this.setState(
      { formErrors: fieldValidationErrors, otpValid: otpValid },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({ formValid: this.state.otpValid });
  }

  errorClass(error) {
    return error.length === 0 ? "" : "is-invalid";
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }

  render() {
    return (
      <div className="col-md-6 col-lg-5 col-xl-4">
        <div className="container my-auto py-4 bg-white shadow-lg rounded">
          <div className="row mt-2">
            <div className="col-11 col-lg-11 mx-auto">
              <h1>Confirm OTP</h1>
              <p className="text-center">
                <img
                  className="img-fluid"
                  src="../images/otp-icon.png"
                  alt="verification"
                />
              </p>
              <p className="text-muted text-2 text-center">
                Please enter the OTP (one time password) to verify your account.
                A Code has been sent to{" "}
                <span className="text-dark text-4">
                  +91 {this.state.mobile}
                </span>
              </p>

              {this.state.errorMessage ? (
                <span
                  style={{ display: "block" }}
                  className="alert alert-warning alert-dismissible fade show"
                >
                  {this.state.errorMessage}
                </span>
              ) : (
                ""
              )}

              <div id="otp-screen" className="form-border" method="post">
                <div className="form-row">
                  <div className="col form-group">
                    <input
                      id="first"
                      inputmode="decimal"
                      pattern="[0-9]*"
                      className="form-control text-center text-6 px-0 py-2"
                      name="otp1"
                      onChange={(event) => this.handleUserInput(event)}
                      maxLength="1"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="col form-group">
                    <input
                      inputmode="decimal"
                      pattern="[0-9]*"
                      className="form-control text-center text-6 px-0 py-2"
                      name="otp2"
                      onChange={(event) => this.handleUserInput(event)}
                      maxLength="1"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="col form-group">
                    <input
                      inputmode="decimal"
                      pattern="[0-9]*"
                      className="form-control text-center text-6 px-0 py-2"
                      name="otp3"
                      onChange={(event) => this.handleUserInput(event)}
                      maxLength="1"
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="col form-group">
                    <input
                      inputmode="decimal"
                      pattern="[0-9]*"
                      className="form-control text-center text-6 px-0 py-2"
                      name="otp4"
                      onChange={(event) => this.handleUserInput(event)}
                      maxLength="1"
                      required
                      autoComplete="off"
                    />
                  </div>
                </div>
                <button
                  disabled={!this.state.formValid}
                  onClick={this._verifyOTP}
                  className="btn btn-primary btn-block my-3"
                  type="button"
                >
                  CONFIRM
                </button>
                <div className="text-center mt-3">
                  <span className="text-muted">Didn't receive the OTP? </span>
                  <a
                    href="javascript:void(0)"
                    onClick={this._resendOTP}
                    className="text-primary font-weight-bold"
                  >
                    Resend OTP
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
export default withRouter(VerifyMobileOTP);
